import { Box, Grid, TextField, Typography, Paper, Chip, Divider, Tooltip, FormControlLabel, Checkbox } from '@mui/material';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from 'lodash';
import InfoIcon from "../../../../asset/image/info-icon.svg";
import { useState } from 'react';

const Notifications = ({ emails, handleDeleteEmail, error, setError, emailInput, setEmailInput, handleAddEmail }) => {
    const [sendToServiceLine, setSendToServiceLine] = useState(true)
    return (
        <>
            <Box className="starlink-section-heading starlink-plans-margin-notif">
                <Typography className="starlink-section-title" >Pool or Plan Associated Email Addresses
                </Typography>
                <Tooltip className='starlink-plans-notif-email' title={`Notifications will be sent to these Email(s)`}>
                    {/* <InfoIcon className="starlink-account-infoIcon" fontSize="small" /> */}
                    <img src={InfoIcon} alt="info" className="info-icon" />
                </Tooltip>
                <Divider className='starlink-section-divider' />
            </Box>
            <Grid item xs={12}>
                <Box>
                    <Paper className='starlink-plans-email'  >
                        {emails?.map((email, index) => (
                            <Chip
                                key={index}
                                label={email?.email}
                                onDelete={() => handleDeleteEmail(email)}
                                sx={{ margin: '4px' }}
                            />
                        ))}
                        <TextField
                            size="small"
                            fullWidth
                            variant="standard"
                            error={!!error}
                            placeholder="Press Enter to add email"
                            helperText={error}
                            value={emailInput}
                           onChange={(e) => {
    setEmailInput(e.target.value);
    if (error) setError(""); // Clear error on change
  }}
                            onKeyDown={handleAddEmail}
                            InputProps={{
                                disableUnderline: true,
                                style: {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    padding: '0 4px',
                                },
                            }}
                            sx={{
                                width: 'auto',
                                flexGrow: 1,
                                minWidth: '120px',
                                '& .MuiInputBase-root': {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                },
                                '& .MuiInputBase-input': {
                                    padding: '8px 4px',
                                    flex: 1,
                                },
                            }}
                        />
                    </Paper>
                </Box>
                {/* <FormControlLabel
                    control={
                        <Checkbox
                            checked={sendToServiceLine}
                            onChange={(e) => setSendToServiceLine(e.target.checked)}
                        />
                    }
                    label="Send to Service Line Associated Email Address"
                    sx={{ mt: 1 }}
                /> */}
            </Grid>
        </>

    );
};

const mapStateToProps = (state) => ({
});

export default withRouter(
    connect(mapStateToProps, {})(Notifications)
)